import { useState } from 'react';
import ActionsDrawer from './ActionsDrawer';
import ControlButton from './base/ControlButton';
import DrawerButton from './base/DrawerButton';
import useViewState from './useViewState';

/**
 * A drawer whose face shows one of its options.
 * With a stateKey (a key of processViewState), the face is the option the display state says is
 * active, so it follows changes made anywhere -- undo, a macro, a command -- not just clicks.
 * Without one, the face is the last option clicked.
 */
export default function ControlDrawer({
    defaultLabel, title, actions, ControlProps, stateKey, ...rest
}) {
    const [controlLabel, setControlLabel] = useState(defaultLabel);
    const viewState = useViewState();
    const active = stateKey && actions.find(({ id }) => id === viewState[stateKey]);

    const control = (
        <ControlButton title={title} {...ControlProps}>
            {active ? active.label : controlLabel}
        </ControlButton>
    );
    const actionButtons = actions.map((action) => {
        const {
            id, desc, label, onClick,
        } = action;

        return (
            <DrawerButton
                key={id}
                title={desc}
                id={id}
                onClick={() => onClick(setControlLabel)}
            >
                {label}
            </DrawerButton>
        );
    });

    return (
        <ActionsDrawer control={control} {...rest}>
            {actionButtons}
        </ActionsDrawer>
    );
}

// TODO: proptypes
